import { useHasMapSync } from './useHasMapSync';
import { type AccountingSoftware } from '../../bookkeep/integration/status';
import { useAccountingSoftwareName } from '../apis';
import {
  useGetAnalyticalFieldExportSettings,
  usePutAnalyticalFieldExportSettings,
} from '../apis/useAnalyticalFieldExportSettings';

type Props = {
  /**
   * The external_id that the field is mapped to
   */
  fieldExternalId: string | undefined;
};

const enabledIntegrations: AccountingSoftware[] = ['Netsuite'];

export const useAnalyticalFieldConfiguration = ({ fieldExternalId }: Props) => {
  const { integration } = useAccountingSoftwareName();
  const hasMapSyncFeature = useHasMapSync();
  const isEnabled =
    hasMapSyncFeature &&
    !!integration &&
    enabledIntegrations.includes(integration);

  const { exportConfig, isLoading } = useGetAnalyticalFieldExportSettings({
    isEnabled,
  });

  const canChangeSettings =
    !!fieldExternalId && !fieldExternalId.includes('customSegment');

  const { updateCompanyExportSettings, isPending } =
    usePutAnalyticalFieldExportSettings();

  return {
    exportConfig,
    isLoading,
    isPending,
    isExportConfigEnabled: isEnabled,
    canChangeSettings,
    updateCompanyExportSettings,
  };
};
